import axiosInstance from "../tokenInterceptor/AxiosInstance";

export class EventService {
  constructor() {
    this.Api = "event"; 
  }

  async getAllEvents() {
    const url = `${this.Api}/events`;
    return axiosInstance.get(url);
  }
}

export default EventService;